import { useSyncExternalStore } from 'react';

function subscribe(query: string, onChange: () => void): () => void {
  const mediaQueryList = window.matchMedia(query);
  mediaQueryList.addEventListener('change', onChange);
  return () => mediaQueryList.removeEventListener('change', onChange);
}

/**
 * Tracks a CSS media query, re-rendering the consumer when it flips.
 * `ResponsiveList` uses this for its table/card breakpoint at 640px.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => subscribe(query, onChange),
    () => window.matchMedia(query).matches,
  );
}
